import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FlavorService } from './flavor.service';

export const retailGroupContextInterceptor: HttpInterceptorFn = (request, next) => {
  const isOrbitApiRequest =
    request.url.startsWith(environment.apiEndpoint) ||
    request.url.startsWith(environment.websiteApiEndpoint);
  if (!isOrbitApiRequest || request.params.has('retailGroupId')) {
    return next(request);
  }

  const retailGroupId = inject(FlavorService).config.retailGroupId.toString();
  return next(
    request.clone({
      params: request.params.set('retailGroupId', retailGroupId),
    })
  );
};
